/*
 * See the file LICENSE for the full license governing this code.
 */

import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { COPYRIGHT_LINK } from '../constants';

export default function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright '}
      <Link color="inherit" href={COPYRIGHT_LINK} target="_blank">
        Franz Inc
      </Link>
      {'.'}
    </Typography>
  );
}
